// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
WebFont.load({
    google: { // add &display=swap to end of every font family
        families: ['Karla:400,500,700&display=swap']
    },
    //,
    // typekit: {
    // id: 'XXXX'
    // },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true 
    }
});

// Load BS
require('bootstrap');

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('slick-slider/slick/slick.min');

require('./plugins/jquery.reframe.min');

//Load Modules
require('./modules/accordion');
require('./modules/animatein');
require('./modules/banner');
require('./modules/formInputs');
require('./modules/localVideoBlock');
require('./modules/menu');
require('./modules/modal');
require('./modules/scrollTo');
require('./modules/searchToggle');
require('./modules/shareSocial');
require('./modules/sideMenu');
require('./modules/tabs');

import ClipboardJS from './modules/clipboard.min';

require('./homepage');
require('./flexpage');
require('./search');
require('./blog-single');
require('./tile-calculator');
require('./autocomplete-search');
require('./cart');

$(document).ready(function() {
    if ($(window).width() > 576) {
        $(".footer-title").addClass("__active");
        $(".footer-content").show();
        $(".footer-content").attr('aria-hidden', false);
    }
    else {
        $(".footer-title").removeClass("__active");
        $(".footer-content").hide();
        $(".footer-content").attr('aria-hidden', true);
    }


    $('.imagemodal').magnificPopup({
        type: 'image',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
    }
    });
});

$(document).ready(function() {
    if(($('#scrollToNewsletter').length) || ($('.newsletter .error_feedback').length)) {
        $(window).scrollTop($('#Newsletter').offset().top)
    }
});

var copyButtons = document.querySelectorAll(".copyToClipboard");
new ClipboardJS(copyButtons).on("success", function (event) {
    event.trigger.classList.remove('__link');
    event.trigger.classList.add('__tick');
    setTimeout(function(){
        event.trigger.classList.remove('__tick');
        event.trigger.classList.add('__link');
    }, 1500);
});
new ClipboardJS(copyButtons).on("error", function (event) {
    console.error("Error with ClipboardJS: " + event);
});

$('.tilelinksblock-view').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
})

$(document).ready(function() {
    $('.sample-wrap').each( (i, el) => {
        $(el).prependTo($(el).closest('form'));
    });
});

if (typeof loadMore !== 'undefined') {
    $(document).on('click', loadMore.button, function(e){

        e.preventDefault();
        // Increase page number
        loadMore.currentPage++;
        // Build URL of where data is being retrieved from
        var url = window.location.href + '?get=' + loadMore.currentPage + loadMore.wrapper;

        // loading content in
        $.get(url, function (data) {

            data = $(data).find(loadMore.element);
            $(loadMore.wrapper).append(data);

            // Add loading animation for new list items if needed
            // $('.__animate').animateIn({
            //     offset: 0,
            //     modifier: '__animatein'
            // });

        }).done(function() {

            // when done, check current page count
            if(loadMore.currentPage >= loadMore.totalPages){
                $(loadMore.button).hide(); // Hide the load more button if last page
            }

            $('.imagemodal').magnificPopup({
                    type: 'image',
                    removalDelay: 160,
                    preloader: false,
                    fixedContentPos: false,
                    gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                }
            });

            $(':focus').trigger('blur');
            $('.loadMoreWrap').find('.loadMoreItem:nth-last-child(' + loadMore.items + ')').find('a').trigger('focus');
            
        });

    })
}

$( ".filterBy" ).change(function() {
    $(this).addClass('__processing');
});


// @BE: script for slider (with annotations) block - not sure if this script needs to go only on the pages where the slider is used?
$(function () {
    $(document).ready(function () {
        $(".slider-annotation-items").each(function () {
            var thisElement = $(this);
            thisElement.slick({
                fade: false,
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: thisElement.closest('.slider-annotation').find('.sliderPrevButton'),
                nextArrow: thisElement.closest('.slider-annotation').find('.sliderNextButton'),
                mobileFirst: true,
                asNavFor: '.slider-annotation-annotations',
                draggable: false,
            });
        })
        $(".slider-annotation-annotations").each(function () {
            var thisElement = $(this);
            thisElement.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: false,
                nextArrow: false,
                mobileFirst: true,
                draggable: false,
                swipe: false
            });
        })
    });
});